import React from 'react';
import { Button, DatePicker, Drawer, Form } from 'antd';
import { DISPLAY_DATE_FORMAT, FILTER_COLLECTION_NAME } from './LifeCycleAnalyticsConstants';
import {
	getLifecycleDateRanges,
	getLifecycleRangePickerDisabledDate,
} from './LifeCycleAnalyticsUtils';
import ProblemTypeTreeSelect from '../problem_type_tree_select';
// import OWRadioGroup from '../ow_radio_group/OWRadioGroup';
// import { WORK_HOURS_TYPE } from './LifeCycleAnalyticsUtils';

// const isPMItems = [
// 	{ label: 'All', value: undefined },
// 	{ label: 'Reactive', value: 'false' },
// 	{ label: 'PM', value: 'true' },
// ];

// const workHoursItems = [
// 	{ label: 'All', value: undefined },
// 	{ label: 'Work Hours (9AM - 5PM)', value: WORK_HOURS_TYPE.WORK_HOURS },
// 	{ label: 'After Hours', value: WORK_HOURS_TYPE.AFTER_HOURS },
// ];

const FilterDrawer = ({
	visible,
	draftFilters,
	problemTypes,
	createdAtPickerDates,
	completedAtPickerDates,
	fetchProblemTypes,
	handleProblemTypeChange,
	handleCreatedAtCalendarChange,
	handleCreatedAtChange,
	handleCreatedAtOpenChange,
	handleCompletedAtCalendarChange,
	handleCompletedAtChange,
	handleCompletedAtOpenChange,
	// handleIsPMChange,
	// handleWorkHoursTypeChange,
	applyFilters,
	cancelFilters,
}) => {
	return (
		<Drawer
			title="Filters"
			placement="right"
			closable={false}
			width={800}
			visible={visible}
			onClose={cancelFilters}
		>
			<Form layout="vertical">
				<Form.Item label="Problem Type">
					<ProblemTypeTreeSelect
						stateSlice={problemTypes}
						targetCollectionName={FILTER_COLLECTION_NAME}
						fetchData={fetchProblemTypes}
						fetchMultiple={() => {}}
						mode="multiple"
						allowClear={true}
						value={draftFilters.problemTypeIds}
						onChange={handleProblemTypeChange}
						style={{ width: '100%' }}
					/>
				</Form.Item>
				<Form.Item label="Created between">
					<DatePicker.RangePicker
						className="w-1/2"
						value={draftFilters.createdAt}
						format={DISPLAY_DATE_FORMAT}
						disabledDate={getLifecycleRangePickerDisabledDate(
							createdAtPickerDates || draftFilters.createdAt
						)}
						onCalendarChange={handleCreatedAtCalendarChange}
						onChange={handleCreatedAtChange}
						onOpenChange={handleCreatedAtOpenChange}
						allowEmpty={[true, true]}
						ranges={getLifecycleDateRanges()}
					/>
				</Form.Item>
				<Form.Item label="Completed between">
					<DatePicker.RangePicker
						className="w-1/2"
						value={draftFilters.completedAt}
						format={DISPLAY_DATE_FORMAT}
						disabledDate={getLifecycleRangePickerDisabledDate(
							completedAtPickerDates || draftFilters.completedAt
						)}
						onCalendarChange={handleCompletedAtCalendarChange}
						onChange={handleCompletedAtChange}
						onOpenChange={handleCompletedAtOpenChange}
						allowEmpty={[true, true]}
						ranges={getLifecycleDateRanges()}
					/>
				</Form.Item>
				{/* TODO: add these filter fields from backend in OPE-4583 */}
				{/* <Form.Item>
					<OWRadioGroup
						items={isPMItems}
						value={draftFilters.isPM}
						valueAccessor={(item) => item.value}
						renderRecord={(item) => item.label}
						onChange={handleIsPMChange}
					/>
				</Form.Item> */}
				{/* <Form.Item>
					<OWRadioGroup
						items={workHoursItems}
						value={draftFilters.workHoursType}
						valueAccessor={(item) => item.value}
						renderRecord={(item) => item.label}
						onChange={handleWorkHoursTypeChange}
					/>
				</Form.Item> */}
			</Form>
			<div className="mt-6 flex gap-2">
				<Button type="primary" onClick={applyFilters}>
					UPDATE FILTERS
				</Button>
				<Button onClick={cancelFilters}>CANCEL</Button>
			</div>
		</Drawer>
	);
};

export default FilterDrawer;
